import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Compatibility wrapper for NavLink that maintains the activeClassName API
 * React Router v6 uses the 'active' class by default on NavLink
 */
export function NavLinkCompat({ activeClassName = 'active', className, ...props }) {
  return (
    <NavLink
      className={({ isActive }) => {
        const classes = [className];
        if (isActive) {
          classes.push(activeClassName);
        }
        return classes.filter(Boolean).join(' ');
      }}
      {...props}
    />
  );
}
